// MATCH Collection 2026 — content parsed from MATCH-Collection-2026-1.pdf
// Renders exported from the same PDF into /public/match/

export const MATCH = {
  title: "MATCH Collection 2026",
  brand: "KEIKI MATCH",
  category: "Modular Surface Collection / CNC Panels",
  claim: "Four repeatable panel systems. One architectural surface language.",
  description:
    "A CNC-routed modular surface system engineered for 6 mm MDF. Designed with precise edge coordinates where repetition and rotation create continuous architectural compositions.",
  systemTitle: "The seam is part of the design.",
  systemText:
    "Every collection starts with a small family of modules. Their lines meet at fixed edge coordinates, so repetition and rotation build a larger composition rather than a wall of unrelated pictures.",
  compositions: "3 / 6 / 8 / 12 / 24-panel compositions",
  heroImage: "/match/hero.jpg",
  systemImage: "/match/system.jpg",
  installImage: "/match/install.jpg",
  matrixImage: "/match/matrix.jpg",
  closingImage: "/match/closing.jpg",
  closingLine: "A wall becomes an artwork when every panel belongs.",
};

export const MATCH_SERIES = [
  {
    id: "kaari",
    no: "01",
    name: "KAARI",
    type: "Architectural / Linear",
    headline: "A measured rhythm of arches and vertical lines.",
    character:
      "Large U-shaped arcs and fine channels continue across panel boundaries. Six modules can be repeated or rotated without losing the calm architectural order.",
    modules: "6 base modules",
    panel: "300 × 600 / 500 × 600 mm",
    layouts: "6 / 8 / 12 / 24 panels",
    image: "/match/kaari.jpg",
  },
  {
    id: "havu",
    no: "02",
    name: "HAVU",
    type: "Geometric / Rhythmic",
    headline: "A directional field built from mirrored modules.",
    character:
      "A compact two-module system produces a continuous herringbone surface. Rotation changes movement and scale while the edge logic remains exact.",
    modules: "2 mirrored modules",
    panel: "300 × 600 mm",
    layouts: "3 / 6 / 12 / 24 panels",
    image: "/match/havu.jpg",
  },
  {
    id: "virta",
    no: "03",
    name: "VIRTA",
    type: "Organic / Sculptural",
    headline: "Contour lines that read as one continuous landscape.",
    character:
      "Three repeatable modules carry generous organic routes over every seam. The wall feels drawn as a whole — not assembled from separate pictures.",
    modules: "3 base modules",
    panel: "400 × 600 mm",
    layouts: "3 / 6 / 12 panels",
    image: "/match/virta.jpg",
  },
  {
    id: "keha",
    no: "04",
    name: "KEHÄ",
    type: "Circular / Compositional",
    headline: "Large rings emerge only when the modules meet.",
    character:
      "The four-module system uses broad, consistent radii. Repetition and rotation complete oversized circles and ellipses across the full composition.",
    modules: "4 base modules",
    panel: "300 × 600 mm",
    layouts: "4 / 8 / 12 / 24 panels",
    image: "/match/keha.jpg",
  },
];

export const MATCH_SPECS = [
  ["Material", "CNC-routed 6 mm MDF"],
  ["Routing depth", "1.5 – 2 mm"],
  ["Installation joint", "2 mm (reusable spacers)"],
  ["Mounting method", "Direct bonding with MS polymer and full-scale template"],
];

export const MATCH_INSTALL = [
  { no: "01", title: "Level", text: "A temporary bottom ledger establishes the first row." },
  { no: "02", title: "Space", text: "Reusable 2 mm crosses preserve every seam and match point." },
  { no: "03", title: "Bond", text: "Flexible high-grab MS polymer is applied in vertical beads." },
];

export const MATCH_MATRIX = [
  ["KAARI 01", "Architectural / calm", "6", "300/500 × 600", "6 / 8 / 12 / 24"],
  ["HAVU 02", "Geometric / directional", "2", "300 × 600", "3 / 6 / 12 / 24"],
  ["VIRTA 03", "Organic / sculptural", "3", "400 × 600", "3 / 6 / 12"],
  ["KEHÄ 04", "Circular / expansive", "4", "300 × 600", "4 / 8 / 12 / 24"],
];

// Three primary product lines shown on the homepage
export const PRODUCT_LINES = [
  {
    id: "match",
    tag: "01",
    name: "MATCH Collection 2026",
    family: "Modular Surface Collection / CNC Panels",
    text: MATCH.description,
    image: "/match/kaari.jpg",
    specs: ["6 mm MDF", "4 series", "24-panel layouts"],
  },
  {
    id: "acoustic",
    tag: "02",
    name: "Acoustic Surface Systems",
    family: "Slat & perforated absorbers",
    text: "Slat-on-felt, perforated and micro-grooved acoustic panels with recycled PET backing. Tested absorption from αw 0.55 to 0.95.",
    image: "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5?w=1100&q=80&auto=format&fit=crop",
    specs: ["Ash / Birch", "21 mm", "αw 0.90"],
  },
  {
    id: "cladding",
    tag: "03",
    name: "CNC Wood Cladding",
    family: "Interior & ventilated facade",
    text: "Fluted and profiled cladding in thermally modified timber with concealed clip rails, delivered with full shop drawings.",
    image: "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f?w=1100&q=80&auto=format&fit=crop",
    specs: ["Thermo Ash", "25 mm", "Rainscreen"],
  },
];
